import type { AuthUser } from "../context/AuthContext";
import { isAuthenticatedPublisher } from "./authAccess";

export const PUBLISHER_SIGN_IN_PATH = "/sign-in";
export const PUBLISH_YOUR_APP_PATH = "/publish-your-app";

export type PublishGuestAuthGateResult =
  | { action: "wait" }
  | { action: "allow" }
  | { action: "redirect"; to: string; state: { from: string } };

/**
 * Unauthenticated visitors may view Publish Your App.
 * Any meaningful publish action requires Publisher Sign In.
 */
export function evaluatePublishGuestAuthGate(input: {
  isLoading: boolean;
  user: AuthUser | null;
  fromPath?: string;
}): PublishGuestAuthGateResult {
  if (input.isLoading) {
    return { action: "wait" };
  }

  if (isAuthenticatedPublisher(input.user)) {
    return { action: "allow" };
  }

  return {
    action: "redirect",
    to: PUBLISHER_SIGN_IN_PATH,
    state: { from: input.fromPath ?? PUBLISH_YOUR_APP_PATH },
  };
}
